import React, { useState } from 'react';
import FileUpload from "./FileUpload";
import icon_download from '../img/icon_download.png';

const MaintenanceModal = ({ description, imageList, documentList, onCancel }) => {
  const [category, setCategory] = useState('');
  const [name, setName] = useState('');
  const [files, setFiles] = useState([]);


  const handleCancel = () => {
     if(onCancel) onCancel();
  }



  return (
    <div className="modal-overlay">
      <div className="modal-box big-modal-box">
        <h2 className="modal-title">Dettaglio Intervento  <span onClick={handleCancel} className="close-popup">&#x2715;</span></h2>


          <div className="vscroll">
            <h3 style={{marginTop: "0px"}}>
            Descrizione
            </h3>
            <p>
            {description}
            </p>

            <h3>
            Documenti
            </h3>

            <div id="maintenance_document_list">
              { documentList.map((doc)=>{
                  console.log(doc);
                  const filename = doc.document.split('/').pop();
                  return <div>
                            <a href={"/media/"+filename} target="_blank">
                              <div>  <img src={icon_download} style={{ width: '38px', cursor: 'pointer', padding: '4px 8px' }} className={`edit-icon`} alt="dowload"/>  {doc.name} </div>
                            </a>
                         </div>
                })
              }
            </div>

            <h3>
            Immagini
            </h3>

            <div id="maintenance_images_list">
              { imageList.map((img)=>{
                  const filename = "/media/uploads/"+(img.split('/').pop());
                  return <a href={filename} target="_blank"><img className="maintenance_image" src={filename} alt="image" /></a>
                })
              }
            </div>
          </div>

        <div className="buttons">
          <button onClick={handleCancel} className="modal-button cancel-button">Indietro</button>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceModal;
